import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from './assets/hooks/scrollToTop';
import mainApi from "./assets/api/MainApi";
import { saveStaticPageData } from "./components/Platform/Settings/PagesAndFiles/components/EditMainPage/services/editMainPageApi";

import "swiper/swiper-bundle.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (typeof window !== "undefined") {
  window.runbackup = async function runbackup(...args) {
    const parseLine = (line) => {
      const parts = String(line || "").split("\t");
      const created_at = parts[0] || "";
      const shop_id = parts[1] || "";
      if (parts.length <= 3) {
        return { created_at, shop_id, layoutJson: parts[2] || "", metaJson: "" };
      }
      const layoutParts = parts.slice(2, parts.length - 1);
      const layoutJson = layoutParts.join("\t");
      const metaJson = parts[parts.length - 1] || "";
      return { created_at, shop_id, layoutJson, metaJson };
    };

    const normalizeArgs = () => {
      if (args.length === 1) {
        return parseLine(args[0]);
      }
      const [created_at, shop_id, layoutJson, metaJson] = args;
      return {
        created_at: created_at || "",
        shop_id: shop_id || "",
        layoutJson: layoutJson || "",
        metaJson: metaJson || "",
      };
    };

    const { shop_id, layoutJson, metaJson } = normalizeArgs();
    if (!shop_id || !layoutJson) {
      throw new Error("runbackup: missing shop_id or layout");
    }

    const parseJsonSafe = (value) => {
      if (typeof value !== "string") return value;
      try {
        return JSON.parse(value);
      } catch (err) {
        const escaped = value
          .replace(/\r\n/g, "\\n")
          .replace(/\r/g, "\\n")
          .replace(/\n/g, "\\n")
          .replace(/\t/g, "\\t");
        return JSON.parse(escaped);
      }
    };

    const layout = parseJsonSafe(layoutJson);
    const meta = metaJson ? parseJsonSafe(metaJson) : null;

    const getBlockId = (item) =>
      item?.block?._id || item?.block?.id || item?.block_id || item?.blockId || null;
    const isEditableType = (item) => Boolean(item?.block?.input_data);

    const layoutForSave = (layout || []).map((item) => {
      const blockId = getBlockId(item);
      if (!blockId) return item;
      const data = isEditableType(item) ? (Array.isArray(item.data) ? item.data : null) : null;
      return {
        ...item,
        block: {
          ...(item.block || {}),
          _id: blockId,
        },
        data,
      };
    });

    const blockIds = layoutForSave.map(getBlockId).filter(Boolean);
    const fallbackBlocks = (meta?.blocks || [])
      .map((block) => block?._id || block?.id)
      .filter(Boolean);
    const blocks = blockIds.length ? blockIds : fallbackBlocks;

    await mainApi.setConstructorMainPage({
      shop_id,
      logo: meta?.logo?._id || null,
      icon: meta?.icon?._id || null,
      blocks,
    });

    await saveStaticPageData(shop_id, layoutForSave);

    console.log("runbackup: restore done");
  };
}
